export default "__VITE_ASSET__DzVFcT2x__"